<template>
  <ValidationProvider
    v-slot="{ errors }"
    :vid="vid"
    :name="name"
    :rules="rules"
    tag="div"
    ref="provider"
  >
    <b-form-tags
      v-model="inputVal"
      class="mb-2"
      :tag-validator="tagValidator"
      :input-id="inputId"
      :disabled="disabled"
      separator=" "
      no-outer-focus
    >
      <template
        v-slot="{
          tags,
          inputAttrs,
          inputHandlers,
          tagVariant,
          addTag,
          removeTag,
          duplicateTags,
        }"
      >
        <div style="font-size: 1rem;">
          <b-form-tag
            v-for="tag in tags"
            @remove="removeTag(tag)"
            :key="tag"
            :title="tag"
            :variant="tagVariant"
            class="mb-1"
          >
            {{ tag }}
          </b-form-tag>
        </div>
        <div class="d-flex">
          <b-form-input
            v-bind="inputAttrs"
            v-on="inputHandlers"
            @change="validateInput"
            @keydown="onKeydown"
            @blur="onBlur"
            :placeholder="placeholder"
            class="border border-white p-0 mr-1"
          >
          </b-form-input>
          <b-button
            id="add-tag-button"
            @click="addTag()"
            variant="outline-secondary"
            v-show="inputAttrs.value"
          >
            加入
          </b-button>
        </div>

        <b-form-invalid-feedback :state="state(duplicateTags)">
          {{ name }} {{ duplicateTags[0] }} 已存在
        </b-form-invalid-feedback>
        <b-form-invalid-feedback :state="state(invalidMessage)">
           <slot name="invalidTag">
            {{ invalidMessage }}
          </slot>
        </b-form-invalid-feedback>
      </template>
    </b-form-tags>
    <b-form-invalid-feedback :state="state(errors)">
      {{ errors[0] }}
    </b-form-invalid-feedback>
  </ValidationProvider>
</template>

<script>
import {
  BButton, BFormTags, BFormTag, BFormInput, BFormInvalidFeedback,
} from 'bootstrap-vue';
import agcFormElementMixin from '../../mixins/agc-form-element';

export default {
  mixins: [agcFormElementMixin],
  components: {
    BButton,
    BFormTags,
    BFormTag,
    BFormInput,
    BFormInvalidFeedback,
  },
  props: {
    inputId: {
      type: String,
      default: 'tags-basic',
    },
    validateRegEx: RegExp,
  },
  data: () => ({
    invalidMessage: '',
  }),
  methods: {
    tagValidator(tag) {
      if (this.validateRegEx) {
        return this.validateRegEx.test(tag);
      }
      return true;
    },
    onBlur(event) {
      const inputElement = event.target;
      if (event.relatedTarget?.id !== 'add-tag-button' && inputElement.value.length) {
        // eslint-disable-next-line no-alert
        window.alert(`請輸入未完成之${this.name}`);
        setTimeout(() => inputElement.focus(), 1);
      }
    },
    validateInput(value) {
      if (value) {
        if (!this.tagValidator(value)) {
          this.invalidMessage = `${this.name}無效`;
        } else {
          this.invalidMessage = '';
        }
      }
    },
    onKeydown(e) {
      if (e.code === 'Enter') {
        this.validateInput(e.target.value);
      } else {
        this.invalidMessage = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .b-form-tags {
    .btn {
      &-outline-secondary {
        width: 14%;
        height: 15%;
        padding: 5px;
      }
    }

    &.disabled {
      .b-form-tag-remove {
        display: none;
      }
    }
  }
}
</style>
